// packages
import { Helmet } from "react-helmet-async";

// components (shared)
import DiamondsUI from "../shared/components/DiamondsUI";

// components (template)
// import Header from "../components/Header";
// import ImageBanner from "../components/ImageBanner";
import StandardContainer from "../components/StandardContainer";

// data
// import { categories } from "../data/categories";

export default function Diamonds() {
  return (
    <>
      <Helmet>
        <title>Diamonds - Ninacci</title>
        <meta
          name="description"
          content="Explore our collection of certified diamonds with exceptional clarity, color, and carat weight."
        />
      </Helmet>
      {/* <Header title="Diamond Search" /> */}
      {/* <ImageBanner image={categories.diamonds.banner} /> */}
      <div className="font-cartier-sans my-4 font-semibold text-black sm:my-8">
        <StandardContainer content={<DiamondsUI />} />
      </div>
    </>
  );
}
